import React from "react";
import gs, { colors } from "gstyles";
import Image from "components/common/Image";
import { IconName } from "gstyles/styleguide/icons";
interface LayoutProps {
  iconName?: IconName;
  title?: string;
  description?: string;
  banner?: string;
  titleStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  iconName = "sun-fog",
  title = "",
  description = "",
  banner = "",
  titleStyle = {},
  style = {},
  children,
}) => {
  return (
    <div className="bg-white">
      <div className="container mx-auto  pb-10 mb-4" style={style}>
        <div className="flex items-start gap-4 px-6 py-6">
          <div className="flex items-center mb-2">
            {iconName &&
              // Giả sử bạn có một component Icon, thay thế bằng icon thực tế của bạn
              gs.icons({ name: iconName, width: 24, color: colors.primary })}
          </div>
          <div>
            <span
              className="uppercase text-lg font-semibold text-black01 opacity-80"
              style={titleStyle}
            >
              {title}
            </span>
            <div className="mt-[2px] text-gray-500 text-base opacity-70">
              {description}
            </div>
          </div>
        </div>
        {banner && (
          <div className="px-6 mb-4">
            <Image
              src={banner}
              alt="Banner"
              wrapClassName="w-full max-w-[343px] aspect-[343/100] rounded-md object-cover"
            />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Layout;
